import { useEffect, useState } from 'react';

export function useBudgetOverlay() {
  const [isBudgetHovered, setIsBudgetHovered] = useState(false);
  const [mousePosition, setMousePosition] = useState({ x: 0, y: 0 });

  useEffect(() => {
    if (!isBudgetHovered) return;

    const handleGlobalMouseMove = (event: MouseEvent) => {
      setMousePosition({ x: event.clientX, y: event.clientY });
    };

    const handleGlobalMouseLeave = () => {
      setIsBudgetHovered(false);
    };

    window.addEventListener('mousemove', handleGlobalMouseMove);
    document.addEventListener('mouseleave', handleGlobalMouseLeave);
    return () => {
      window.removeEventListener('mousemove', handleGlobalMouseMove);
      document.removeEventListener('mouseleave', handleGlobalMouseLeave);
    };
  }, [isBudgetHovered]);

  const handleBudgetMouseEnter = () => {
    setIsBudgetHovered(true);
  };

  const handleBudgetMouseLeave = () => {
    setIsBudgetHovered(false);
  };

  return {
    isBudgetHovered,
    mousePosition,
    handleBudgetMouseEnter,
    handleBudgetMouseLeave,
  };
}
